module.exports = __webpack_public_path__ + "img/benevolent-birthdays.1f975c43.png";